<template>
	<div class="row" style="margin-top: 10px;">
		<div class="col-md-1">
			Федеральный округ
		</div>
		<div class="col-md-3">
			<select v-model="selected_fo" class='form-control my-control'>
				<option v-for="option in options_fo" :value='option.id'>
					{{ option.name }}
				</option>
			</select>
		</div>
		<div class="col-md-1 text-center">
			Субъект РФ
		</div>
		<div class="col-md-3">
			<select v-model="selected_region" class='form-control my-control'>
				<option v-for="option in options_region" :value='option.id'>
					{{ option.name }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
	import {DB} from './../../constants'
	const GET_FO = 'get_fo.php'
	const GET_REGIONS = 'region_list.php'

	import {EventBus} from '../../lib/EventBus'

	export default {
		name: 'RegionsList',
		data: function () { 
			return {
				selected_fo: '',
				options_fo: [],
				selected_region: '',
				options_region: [],
				skip_emit: false
			}
		},
		watch: {
			selected_fo (val) {
				if(this.selected_region)
					this.skip_emit = true
				this.fill_region(val)
				EventBus.$emit(`change_fo`, this.options_fo.find(e => {return e.id == val}))
			},
			selected_region (val) {
				if(val)
				{
					EventBus.$emit(`change_regions`, [this.options_region.find(e => {return e.id == this.selected_region})])	
					this.select_fo(val)
				}
				else
					EventBus.$emit(`change_regions`, this.options_region)					
			},
			options_region (val) {
				if(!this.selected_region)
				{
					if(this.skip_emit)
						this.skip_emit = false
					else
						EventBus.$emit(`change_regions`, this.options_region)
				}
			}
		},
		methods: {
			select_fo (region_id) {
				fetch(DB + GET_FO + '?id=' + region_id, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.selected_fo = data[0].id
					}
					else {
						this.selected_fo = null
					}
				})
				.catch(err => console.log(err))
			},
			fill_fo () {
				fetch(DB + GET_FO, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options_fo = [{id: 0, name: 'Все федеральные округа'}, ...data]
						this.selected_fo = this.options_fo[0].id
					}
					else {
						this.options_fo = []
						this.selected_fo = null
					}
				})
				.catch(err => console.log(err))
			},
			fill_region (id) {
				fetch(DB + GET_REGIONS + `?id=${id}`, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						if(id == 0)
							this.options_region = [{id: 0, name: 'Все субъекты РФ'}, ...data]
						else
							this.options_region = [{id: 0, name: 'Все субъекты федерального округа'}, ...data]
						
						if(!this.options_region.find(e => {return e.id === this.selected_region}))
							this.selected_region = this.options_region[0].id
					}
					else {
						this.options_region = []
						this.selected_region = null
					}

				})
				.catch(err => console.log(err))
			}
		},
		created: function () {
			this.fill_fo()
		},
		beforeDestroy () {
		}
	}
</script>


// WEBPACK FOOTER //
// RegionsList.vue?bd570ac6